import React from "react";
import { Card, Avatar, Typography, Tag, Tooltip, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import {
  UserOutlined,
  MailOutlined,
  EditOutlined,
  DeleteOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const { Meta } = Card;
const { Text, Link } = Typography; // Importamos Link

export function TherapistCard({ therapist, onEdit, onDelete, onViewPatients }) {
  // Dos namespaces: el propio de la pantalla y el comun, que ya trae "Editar",
  // "Cancelar" y el "Si, eliminar" de las confirmaciones.
  const { t } = useTranslation(["institution", "common"]);

  // Recibimos onViewPatients
  const fullName = `${therapist.firstname} ${therapist.lastname}`;
  // Ahora pacientes es un array de objetos, pero .length sigue funcionando igual
  const patientsCount = therapist.pacientes ? therapist.pacientes.length : 0;

  return (
    <Card
      hoverable
      style={{ borderRadius: 12, overflow: "hidden" }}
      actions={[
        <Tooltip title={t("common:actions.edit")}>
          <EditOutlined key="edit" onClick={() => onEdit(therapist)} />
        </Tooltip>,
        <Popconfirm
          title={t("therapists.card.deleteTitle")}
          // Frase con hueco, no cadena pegada: en frances el orden de las
          // palabras cambia y una concatenacion no se puede traducir.
          description={t("therapists.card.deleteConfirm", {
            name: therapist.firstname,
          })}
          onConfirm={() => onDelete(therapist)}
          okText={t("common:confirm.yes")}
          cancelText={t("common:actions.cancel")}
          okButtonProps={{ danger: true }}
        >
          <DeleteOutlined key="delete" style={{ color: "#ff4d4f" }} />
        </Popconfirm>,
      ]}
    >
      <div style={{ position: "absolute", top: 12, right: 12 }}>
        <Tag color={therapist.active ? "success" : "default"}>
          {therapist.active
            ? t("therapists.card.active")
            : t("therapists.card.inactive")}
        </Tag>
      </div>

      <Meta
        avatar={
          <Avatar
            src={therapist.avatar}
            size={64}
            icon={<UserOutlined />}
            style={{ backgroundColor: "#1890ff", verticalAlign: "middle" }}
          />
        }
        title={<span style={{ fontSize: 16 }}>{fullName}</span>}
        description={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              marginTop: 8,
            }}
          >
            <Text type="secondary" ellipsis={{ tooltip: therapist.email }}>
              <MailOutlined style={{ marginRight: 6 }} />
              {therapist.email}
            </Text>

            {/* ENLACE CLICABLE */}
            <div
              onClick={() => onViewPatients(therapist)}
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <TeamOutlined style={{ marginRight: 6, color: "#1890ff" }} />
              <Link style={{ fontSize: 14 }}>
                {/*
                  Plural de verdad, no un texto fijo. "1 Usuarios asignados"
                  ya estaba mal en castellano; y en frances el CERO va en
                  singular, al reves que aqui. i18next lo resuelve con las
                  reglas de cada idioma.
                */}
                {t("therapists.card.patientsAssigned", {
                  count: patientsCount,
                })}
              </Link>
            </div>
          </div>
        }
      />
    </Card>
  );
}
